import React from "react";
import { toMin, pretty, num, musicClass } from "./helpers";

// Horizontal "day map": every scheduled bell becomes a clickable tick placed on
// a timeline, colour-coded by its music category. Clicking a tick auditions that
// bell (via onPick).
function DayRibbon({ rows, t, clashSet, onPick, activeId }) {
    const placed = rows
        .filter((r) => r.time)
        .sort((a, b) => toMin(a.time) - toMin(b.time));

    if (!placed.length) {
        return (
            <div className="dg-ribbon">
                <div className="dg-ribbon-empty">{t.ribbonEmpty}</div>
            </div>
        );
    }

    const ts = placed.map((r) => toMin(r.time));
    const lo = Math.floor((Math.min(...ts, 480) - 30) / 60) * 60;
    const hi = Math.ceil((Math.max(...ts, 960) + 30) / 60) * 60;
    const span = Math.max(hi - lo, 120);
    const pct = (m) => ((m - lo) / span) * 100;

    const hours = [];
    for (let m = lo; m <= hi; m += 60) hours.push(m);

    return (
        <div className="dg-ribbon">
            {hours.map((m) => (
                <div key={m} className="dg-hour" style={{ left: pct(m) + "%" }}>
                    {pretty(m).replace(":00", "")}
                </div>
            ))}
            <div className="dg-rail" />
            {placed.map((r) => (
                <button
                    key={r.id}
                    type="button"
                    className={
                        "dg-tick " +
                        musicClass(r.music) +
                        (clashSet.has(r.id) ? " clash" : "") +
                        (activeId === r.id ? " on" : "")
                    }
                    style={{ left: pct(toMin(r.time)) + "%" }}
                    title={`${r.name || "—"} · ${pretty(toMin(r.time))} · ${num(r.dur, 10)}${t.sec}`}
                    onClick={() => onPick(r)}
                >
                    <span className="dg-dot" />
                    <span className="dg-tick-lbl">
                        {pretty(toMin(r.time)).replace(/ [AP]M/, "")}
                    </span>
                </button>
            ))}
        </div>
    );
}

export default DayRibbon;
